import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../../../../helper/to_dangerous_react_html';
import getTranslatedText from '../../../../../helper/get_translated_text';
import Translation from '../../../../translation/translation';
import Countdown from 'react-countdown';
import {getShippingEta} from "../../../../../../_modules/shipping/eta/get_shipping_eta";

export function Costs(props) {
    const hasWheelAlignment = props.wheelAlignment && props.wheelAlignmentWheelCount;
    const CountdownComplete = () => <div
        className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
        <div className="fsf-station-overview__cell">
            <Translation
                translationKey="fitting-station-finder-overview-order-today-fitted-tomorrow"
            />
        </div>
    </div>;

    let dateObj = new Date();
    dateObj.setHours(23, 59, 0, 0);
    if (props.isMarketplaceSeller && props.isMpsProduct) {
        if (props.mpsDoesSameDayFittingCutoff.length === 5) {
            let mpsCutoffTimeParts = props.mpsDoesSameDayFittingCutoff.split(':');
            dateObj.setHours(mpsCutoffTimeParts[0], mpsCutoffTimeParts[1], 0, 0);
        }
    }

    const countdownExpressOrderRenderer = ({hours, minutes, seconds, completed}) => {
        if (completed) {
            // Render a completed state
            return <CountdownComplete/>
        } else {
            // Render a countdown
            return <div
                className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                <div className="fsf-station-overview__cell">
                    <Translation
                        className="fsf-station-overview__express-order-label"
                        translationKey="fitting-station-finder-overview-express-order-within"
                        placeholder={{countdownExpressHours: hours, countdownExpressMinutes: minutes}}
                    />
                </div>
            </div>
        }
    };

    const countdownOrderNowFitTomorrowRenderer = ({hours, minutes, seconds, completed}) => {
        if (completed) {
            // Render a completed state
            return <CountdownComplete/>
        } else {
            // Render a countdown
            return <div
                className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                <div className="fsf-station-overview__cell">
                    <Translation
                        translationKey="fitting-station-finder-overview-order-within-today-fitted-tomorrow"
                        placeholder={{countdownCutoffHours: hours, countdownCutoffMinutes: minutes}}
                    />
                </div>
            </div>
        }
    };

    return (
        <div className="fsf-station-overview__costs-summary">
            {hasWheelAlignment
                && props.wheelAlignment2IsShowable
                && props.wheelAlignmentWheelCount === 2
                &&
                <div
                    className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                    <div className="fsf-station-overview__cell">
                        <Translation
                            className="fsf-station-overview__wheel-alignment-label"
                            translationKey="fitting-station-finder-costs-summary-wheel-2-alignment-label"
                            placeholder={{wheelCount: props.wheelAlignmentWheelCount}}
                        />

                        {' '}
                        <span
                            className="fsf-station-overview__remove-wheel-alignment"
                            onClick={evt => {
                                evt.stopPropagation();
                                props.onWheels2Change();
                            }}
                        >
                                Remove
                            </span>
                    </div>
                    <div className="fsf-station-overview__cell">
                        <div dangerouslySetInnerHTML={toDangerousReactHtml(props.wheelAlignment)}/>
                    </div>
                </div>
            }
            {hasWheelAlignment
                && props.wheelAlignment4IsShowable
                && props.wheelAlignmentWheelCount !== 2
                &&
                <div
                    className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                    <div className="fsf-station-overview__cell">
                        <Translation
                            className="fsf-station-overview__wheel-alignment-label"
                            translationKey="fitting-station-finder-costs-summary-wheel-4-alignment-label"
                            placeholder={{wheelCount: props.wheelAlignmentWheelCount}}
                        />

                        {' '}
                        <span
                            className="fsf-station-overview__remove-wheel-alignment"
                            onClick={evt => {
                                evt.stopPropagation();
                                props.onWheels4Change();
                            }}
                        >
                            Remove
                        </span>
                    </div>
                    <div className="fsf-station-overview__cell">
                        <span dangerouslySetInnerHTML={toDangerousReactHtml(props.wheelAlignment)}/>
                        <span className="fsf-station-overview__checked-icon"></span>
                    </div>
                </div>
            }
            {!props.isMpsProduct && props.fittingPromotion && props.fittingPromotion.promotionName === "free_fitting" &&
            <div
                className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                <div className="fsf-station-overview__cell">
                    <span className="free-fitting">{props.fittingPromotion.promotionText}</span>
                </div>
            </div>
            }

            {!props.isMpsProduct && props.fittingPromotion && props.fittingPromotion.promotionName === "next_day_fitting" &&
            <div
                className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                <div className="fsf-station-overview__cell">
                    <span>{props.fittingPromotion.promotionText}</span>
                </div>
            </div>
            }

            {!props.isMpsProduct && !props.fittingPromotion && !props.disableFitter &&
            <div
                className="fsf-station-overview__row fsf-station-overview__row--costs fsf-station-overview__row--single-item">
                <div className="fsf-station-overview__cell">
                    {getShippingEta(props.etaFrom, props.etaTo)}
                </div>
            </div>
            }

            {props.isMarketplaceSeller && props.mpsDoesSameDayFitting && props.isMpsProduct &&
            <Countdown
                date={dateObj.getTime()}
                renderer={countdownExpressOrderRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
            />
            }

            {props.isMarketplaceSeller && !props.mpsDoesSameDayFitting && props.isMpsProduct &&
            <Countdown
                date={dateObj.getTime()}
                renderer={countdownOrderNowFitTomorrowRenderer}
                zeroPadTime={2}
                zeroPadDays={2}
            />
            }
        </div>
    );
}

Costs.propTypes = {
    wheelAlignment: PropTypes.string.isRequired,
    wheelAlignmentWheelCount: PropTypes.number.isRequired,
    wheelAlignment2IsShowable: PropTypes.bool,
    wheelAlignment4IsShowable: PropTypes.bool,
    totalShipping: PropTypes.string.isRequired,
    etaFrom: PropTypes.instanceOf(Date),
    etaTo: PropTypes.instanceOf(Date),
    calloutFee: PropTypes.string,
    totalCart: PropTypes.string.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    tyreBrand: PropTypes.string,
    staticUrl: PropTypes.string,
    isMarketplaceSeller: PropTypes.bool,
    isMpsProduct: PropTypes.bool,
    mpsDoesSameDayFitting: PropTypes.bool,
    mpsDoesSameDayFittingCutoff: PropTypes.string,
    disableFitter: PropTypes.bool,
};

Costs.defaultProps = {
    disableFitter: false,
    calloutFee: '',
    tyreBrand: '',
    isMarketplaceSeller: false,
    mpsDoesSameDayFitting: false,
    isMpsProduct: false,
};
